// JS file for Contact
import u from '@main';

// u.$ui.bootstrap.tooltip();

const form = '#contact-form';

u.formValidation()
  .then(() => u.$ui.disableOnSubmit(form));
u.form(form).initComponent();
u.$ui.keepAlive(location.href);

$(() => {
  const message = u.data('message')[0];

  const swalWithClass = Swal.mixin({
    customClass: {
      confirmButton: 'my-confirm-button'
    }
  });

  if (message === 'contact') {
    swalWithClass.fire({
      title: '表單已送出',
      text: '將有專人盡快與您聯絡！',
      showCloseButton: true,
      confirmButtonText: '確定',
      confirmButtonColor: '#41a9a5',
    })
  }
});
